
import {ACCESS_FILE_IMAGE_TYPE} from "./common/constants.js";
import UserRepository from './../js/repositories/admin/UserRepository.js';
import { result } from "lodash";

export const allowedImageType = (file) => {
    const fileType = file.name.split('.').at(-1);
    return ACCESS_FILE_IMAGE_TYPE.includes(fileType);
};

export const allowedIconType = (file) => {
    const fileType = file.name.split('.').at(-1);
    return ACCESS_FILE_IMAGE_TYPE.includes(fileType);
};

export const AdminRole = async () => {
    const res = await UserRepository.getAdminAuth();
    return res.data.user?.role;
};

export const convertStringToArray = (str) => {
    let result = [];
    if (str.length > 0) {
        result = str.split(',');
    }
    return result;
}

export const calProductPriceAfterSale = (price, salePrice ) => {
    let result = 1;
    if (salePrice >= 0) {
        let totalString =  (parseFloat(price) * (1 - parseFloat(salePrice) / 100)).toString();
        if (totalString.includes('.')) {
            totalString = totalString.slice(0, totalString.indexOf('.') + 3);
        }
        result = parseFloat(totalString).toLocaleString('en-US');
    }
    return result;
}

export const convertPrice = (price) => {
    return parseFloat(price).toLocaleString('en-US');
}

export const removeItemFromSession = (sesionName) => {
    sessionStorage.removeItem(sesionName);
}
